import { DefaultUrlSerializer } from '@angular/router';
import { isSupportedLanguage, Language } from '@core/enums/language';

const LANG_PARAM = 'lang';

export function getLanguageFromLocationParam(): Language | null {
  const serializer = new DefaultUrlSerializer();
  const url = serializer.parse(location.search);
  const langValue = url.queryParams[LANG_PARAM];
  if (isSupportedLanguage(langValue)) {
    return langValue;
  }

  return null;
}

export function navigateToLocationWithLang(lang: Language): void {
  const serializer = new DefaultUrlSerializer();
  const url = serializer.parse(location.pathname + location.search + location.hash);
  url.queryParams[LANG_PARAM] = lang;
  location.replace(serializer.serialize(url));
}

export function withLanguageParam(absoluteUrl: string, lang: Language): string {
  const url = new URL(absoluteUrl);
  url.searchParams.set(LANG_PARAM, lang);
  return url.toString();
}
